export default {
  get name(): string {
    return 'ExpoHapticsMods';
  },
};
